import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPet = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={14}
      fill="none"
      viewBox="0 0 16 14"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M11.7971 3.01074C11.9239 1.52775 11.1526 0.257658 10.0744 0.173896C8.99614 0.0901339 8.01922 1.22443 7.89238 2.70741C7.76554 4.19039 8.53682 5.46048 9.61507 5.54424C10.6933 5.62801 11.6702 4.49372 11.7971 3.01074Z"
        fill="currentColor"
      />
      <path
        d="M14.1119 7.12458C14.627 6.0419 14.4061 4.88833 13.6185 4.54802C12.831 4.2077 11.7749 4.8095 11.2598 5.89218C10.7448 6.97486 10.9656 8.12842 11.7532 8.46874C12.5408 8.80905 13.5968 8.20725 14.1119 7.12458Z"
        fill="currentColor"
      />
      <path
        d="M5.46595 5.53956C6.543 5.44271 7.29723 4.16336 7.15058 2.68204C7.00392 1.20072 6.01192 0.07838 4.93487 0.175228C3.85783 0.272075 3.1036 1.55143 3.25025 3.03275C3.3969 4.51407 4.38891 5.63641 5.46595 5.53956Z"
        fill="currentColor"
      />
      <path
        d="M3.29133 8.46767C4.07889 8.12735 4.29978 6.97379 3.78468 5.89111C3.26959 4.80843 2.21358 4.20663 1.42601 4.54695C0.638448 4.88727 0.417564 6.04083 0.932655 7.12351C1.44775 8.20618 2.50376 8.80799 3.29133 8.46767Z"
        fill="currentColor"
      />
      <path
        d="M9.94538 8.26208C9.21492 7.20224 8.18473 7.10547 7.82277 7.10547C7.73597 7.10547 7.64753 7.10547 7.56072 7.10547C7.20041 7.10547 6.16858 7.20068 5.43812 8.26208C4.74205 9.27353 3.70204 10.8157 3.26802 11.4588C3.04364 11.7912 2.9552 12.1924 3.03381 12.581C3.13044 13.0602 3.48749 13.5753 4.5668 13.5956C5.1122 13.605 5.6494 13.4832 6.13419 13.246C6.47486 13.0805 6.98258 12.8823 7.46737 12.8885C7.61641 12.8901 7.76545 12.8901 7.91449 12.8885C8.39929 12.8823 8.90701 13.0805 9.24767 13.246C9.73246 13.4832 10.2713 13.605 10.8151 13.5956C11.8944 13.5753 12.2514 13.0602 12.3481 12.581C12.4267 12.1924 12.3382 11.7912 12.1138 11.4588C11.6798 10.8157 10.6398 9.27353 9.94374 8.26208H9.94538Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
